import Tooltip from "app/static/frontend/components/Tooltip"
import classNames from "classnames"
import constants from "app/static/frontend/sheets/constants"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import { hasValidFields, isDisabled } from "app/static/frontend/sheets/components/cells/action-buttons/helperFunctions"
import { columnGridConnection } from "app/static/frontend/sheets/components/cells/action-buttons/selectors"

/**
 * The Action Column Grid displays a grid of Action Buttons specified in buttons
 * Each button is required to have a name, icon, and an action button component in the object.
 * Fields required to run each Action Button should be listed in the column's field list
 * and then passed down in the display function in the parameter 'fields'.
 */
export const ActionColumnGrid = ({ buttons, fields, format, isDark, ...props }) => {
    const renderActionButton = (button, format) => {
        const ActionButton = button.action
        if (format === constants.ACTION_COLUMN_GRID_FORMAT.COMPRESSED) {
            return (
                <Tooltip label={button.name} placement="top">
                    <div>
                        <ActionButton
                            fields={fields}
                            icon={button.icon}
                            variant={button.variant}
                            type={`action-idle-compressed${isDark ? "-dark" : ""}`}
                        />
                    </div>
                </Tooltip>
            )
        }

        return (
            <ActionButton
                fields={fields}
                icon={button.icon}
                text={button.name}
                variant={button.variant}
                type={`action-idle${isDark ? "-dark" : ""}`}
            />
        )
    }

    return (
        <span className="action-column-grid">
            {buttons
                .filter((button) => hasValidFields(button, fields, props))
                .map((button) => (
                    <div
                        key={button.name}
                        className={classNames({
                            "action-button": !isDisabled(button, fields, props),
                            "disabled-action-button": isDisabled(button, fields, props),
                        })}
                    >
                        {renderActionButton(button, format)}
                    </div>
                ))}
        </span>
    )
}

ActionColumnGrid.propTypes = {
    buttons: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    fields: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    format: PropTypes.string,
    isDark: PropTypes.bool,
}

const ConnectedActionColumnGrid: React.ComponentType<{
    buttons?: any[]
    format?: any
    shouldDisableRowLink?: boolean
    isDark?: boolean
    fields?: any
}> = connect((state, props) => columnGridConnection(state, props))(ActionColumnGrid)

ConnectedActionColumnGrid.defaultProps = {
    buttons: [],
    format: constants.ACTION_COLUMN_GRID_FORMAT.DEFAULT,
    shouldDisableRowLink: true,
    isDark: false,
}

export default ConnectedActionColumnGrid
